import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-16 px-4 bg-[#C8956C] text-white" data-id="element-151">
      <div className="max-w-3xl mx-auto text-center" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-153">
          <div className="flex justify-center gap-2 mb-6" data-id="element-154">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-8 h-8 fill-current text-[#FDF8F0]" data-id="element-155" />)}
          </div>
          <p className="text-2xl md:text-3xl font-heading font-medium leading-relaxed" data-id="element-156">
            "En solo 7 días, notarás que la piel de tu abdomen está más firme,
            tus digestiones son más ligeras y, lo más importante, esa marca que
            deja el elástico de tu ropa interior comenzará a desaparecer, señal
            de que la retención de agua ha cedido."
          </p>
        </motion.div>
      </div>
    </section>;
}